<div class="sso-logout-wrapper">
  <div class="sso-logout-container">
    <div class="sso-logout__content">
      <h1 class="sso-logout__title" [translate]="'GlobalNav:NavSsoLogoutHeader'">Logout</h1>
      <p class="sso-logout__message" [translate]="'GlobalNav:NavSsoLogoutBody'">logout successfully.</p>
    </div>
  </div>
</div>
